import { isAiBriefAvailable } from '@fiverr-private/ai_brief';
import { useRelevantGigs } from '../../../hooks/useRelevantGigs';
import { useFreelancerPageContext } from '../../FreelancerPageContext';

export const useBriefAiAvailablity = () => {
    const { gigs } = useFreelancerPageContext();
    const mostRelevantGig = useRelevantGigs(gigs)?.[0];

    return !!mostRelevantGig && isAiBriefAvailable();
};
